module.exports = __webpack_public_path__ + "jpg/quick-registration-bg.jpg?a97095eaa6bbbcfa051182884b003c95";